<div *ngIf="error" id="error-message" class="alert alert-warning alert-dismissible" role="alert">
{{error.show_message}}
</div>
